import type { DirectiveBinding } from 'vue'
import { maskSensitive, type MaskOptions } from '@/utils/mask'

function applyMasking(el: HTMLElement, binding: DirectiveBinding) {
  const { value } = binding

  if (typeof value === 'string' || typeof value === 'number' || value == null) {
    // 直接传入基本类型，使用默认选项
    el.textContent = maskSensitive(value)
  } else if (typeof value === 'object' && value !== null) {
    // 传入对象，包含字符串和选项
    const { text, ...options } = value
    el.textContent = maskSensitive(text, options)
  } else {
    // 其他情况，显示默认占位符
    el.textContent = '--'
  }
}

export default {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    applyMasking(el, binding)
  },

  updated(el: HTMLElement, binding: DirectiveBinding) {
    applyMasking(el, binding)
  },
}
